import React  from 'react';
import { Form, Input, TimePicker, Select  } from 'antd';
import { useLecturerCode } from 'hooks';
import { selectBoxFilterOption } from 'utils/form-utils';
import { DatePicker } from 'components/atoms'

interface FormItemProps {
  form: any
}

const DebirefingFormItem = ({form}: FormItemProps): React.ReactElement => {

  const { lecturerCodeList } = useLecturerCode();  

  return (
    <>
      <Form.Item name="debriefing_date" style={{ width:'120px', display: 'inline-block', marginRight: '5px' }}>
        <DatePicker showTime={false} format="YYYY-MM-DD" />      
      </Form.Item>     
      <Form.Item name="debriefing_time" style={{ width:'200px', display: 'inline-block', marginRight: '5px' }}>
        <TimePicker.RangePicker format={'HH:mm'} minuteStep={5}/>      
      </Form.Item> 
      <Form.Item name="lecturer_srl" style={{ width:'150px', display: 'inline-block', marginRight: '5px' }}>
        <Select 
          style={{width:'200px' }} 
          placeholder={'강사'}
          virtual={false}
          showSearch={true} 
          options={lecturerCodeList}       
          optionFilterProp="label"     
          filterOption={selectBoxFilterOption}
        />                
      </Form.Item> 
    </>
  );
};

export default DebirefingFormItem;
